import styled, { css, keyframes } from 'styled-components';

const riseIn = keyframes`
  from {
    transform: translateY(0.75rem);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

export const Overlay = styled.div(
  ({ theme }) => css`
    /* A standalone takeover: above the app header and sidebar, whichever page opens it. */
    position: fixed;
    inset: 0;
    z-index: ${theme.zi.modal};
    display: flex;
    align-items: flex-start;
    justify-content: center;
    overflow-y: auto;
    background: linear-gradient(
      180deg,
      ${theme.co.primary98} 0%,
      ${theme.co.primary99} 50%,
      ${theme.co.neutral99} 100%
    );
    padding: ${theme.sz.s6} ${theme.sz.s5} ${theme.sz.s10};
  `,
);

export const Content = styled.div(
  ({ theme }) => css`
    width: 100%;
    max-width: 420px;
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s5};
    margin: auto 0;
    text-align: center;
  `,
);

export const Label = styled.span(
  ({ theme }) => css`
    ${theme.typography.paragraph.s};
    padding: ${theme.sz.s2} ${theme.sz.s4};
    border-radius: ${theme.bo.round};
    background: ${theme.co.secondary20};
    color: ${theme.co.primary40};
    font-weight: 700;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    animation: ${riseIn} 0.4s ease-out both;
  `,
);

export const Title = styled.h2(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.m};
    color: ${theme.co.secondary20};
    margin: 0;
    animation: ${riseIn} 0.4s ease-out 0.1s both;
  `,
);

export const Description = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.l};
    color: ${theme.co.secondary50};
    margin: 0;
    animation: ${riseIn} 0.4s ease-out 0.2s both;
  `,
);

export const Stage = styled.div(
  ({ theme }) => css`
    position: relative;
    display: flex;
    align-items: center;
    justify-content: center;
    width: 55%;
    max-width: 220px;
    aspect-ratio: 1;
    border-radius: ${theme.bo.elliptical};
    border: ${theme.sz.s2} solid ${theme.co.neutral99};
    background: ${theme.co.primary30};
    overflow: hidden;
    box-shadow: 0 ${theme.sz.s2} ${theme.sz.s5} rgba(41, 55, 73, 0.18);
    animation: ${riseIn} 0.4s ease-out 0.3s both;
  `,
);

export const Video = styled.video`
  width: 100%;
  height: 100%;
  object-fit: cover;
`;

export const Placeholder = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  width: 100%;
  height: 100%;

  svg {
    width: 100%;
    height: 100%;
    display: block;
  }
`;

export const PlayButton = styled.button(
  ({ theme }) => css`
    position: absolute;
    inset: 0;
    display: flex;
    align-items: center;
    justify-content: center;
    margin: 0;
    padding: 0;
    border: none;
    background: rgba(0, 0, 0, 0.4);
    color: ${theme.co.neutral99};
    font-size: ${theme.sz.s8};
    cursor: pointer;
  `,
);

export const Caption = styled.div(
  ({ theme }) => css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: ${theme.sz.s1};
    animation: ${riseIn} 0.4s ease-out 0.4s both;
  `,
);

export const Phrase = styled.p(
  ({ theme }) => css`
    ${theme.typography.heading.mobile.s};
    color: ${theme.co.secondary20};
    margin: 0;
  `,
);

export const Translation = styled.p(
  ({ theme }) => css`
    ${theme.typography.paragraph.m};
    color: ${theme.co.secondary50};
    margin: 0;
  `,
);

export const Footer = styled.div(
  ({ theme }) => css`
    width: 100%;
    display: flex;
    flex-direction: column;
    gap: ${theme.sz.s3};
    padding-top: ${theme.sz.s2};
    animation: ${riseIn} 0.4s ease-out 0.5s both;
  `,
);
